import React from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";


import MapStyles from "./Mapstyles";
import covidData from "./data2.json";
import {useEffect} from 'react';
import { FaTelegram } from "react-icons/fa";
import { AiOutlineWhatsApp } from "react-icons/ai";
import safeentryimg from "./safeentry.png";

const libraries = ["places"];
const mapContainerStyle = {
  height: "100vh",
  width: "100vw",
};
const options = {
  styles: MapStyles,
  disableDefaultUI: true,
  zoomControl: true,
};
const center = {
    lat: 1.3548,
    lng: 103.8308
};

var daysBefore = new Date(Date.now() - 12960e5);
let covidDate;

export default function Maps() {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyBwSXLlKlyiUGcIqQIDmpD06Lxw4WqUNoQ",
    libraries,
  });
  const [markers, setMarkers] = React.useState([]);
  const [selected, setSelected] = React.useState(null);
  const [covidPlaces, setCovidPlaces] = React.useState(covidData);
  const [recentCovidPlaces, setRecentCovidPlaces] = React.useState([]);


  const onMapClick = React.useCallback((e) => {
    setMarkers((current) => [
      ...current,
      {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
        time: new Date(),
      },
    ]);
  }, []);

  // const mapRef = React.useRef();
  // const onMapLoad = React.useCallback((map) => {
  //   mapRef.current = map;
  // }, []);

  // const placesLatLng = async () => {
  //   covidPlaces.map(async (place) => {
  //     try {
  //       const results = await getGeocode(place.location[0]);
  //       const { lat, lng } = await getLatLng(results[0]);
  //       place["lat"] = lat
  //       place["lng"] = lng
  //     } catch (error) {
  //       console.log("error");
  //     }
  //   });
  // };
  //

  // placesLatLng();
  // console.log(covidPlaces);

  const placesDate = () => {
    covidPlaces.map((place) => {
      covidDate = new Date(place.formatdate)
      // if (covidDate > daysBefore) {
      //   recentCovidPlaces.push(place)
      // }
      recentCovidPlaces.push(place);
    })
  }

  placesDate();

  if (loadError) return "Error";
  if (!isLoaded) return "Loading...";

  return (
    <div>
      <GoogleMap
        id="map"
        mapContainerStyle={mapContainerStyle}
        zoom={12}
        center={center}
        options={options}
        // onClick={onMapClick}
        // onLoad={onMapLoad}
      >
        {recentCovidPlaces.map((place, index) => (
          <Marker
            key={index}
            position={{lat: place.lat , lng: place.lng}}
            onClick={() => {
              setSelected(place);
            }}
          />
        ))}

        {selected && (
          <InfoWindow
            position={{ lat: selected.lat, lng: selected.lng }}
            onCloseClick={() => {
              setSelected(null);
            }}
          >
            <div className='information-container'>
              <h3 className='covid-place-visited'>Place Visited : {selected.location[0].address}</h3>
              <p className='covid-date'>Date : {selected.date}</p>
              <p className='covid-time'>Time : {selected.time}</p>
              <div class="share-place-buttons">
                <i className='help-inform-msg'>Help and Inform Someone. &nbsp;&nbsp;</i>
                <a class="whatsapp" href={`https://api.whatsapp.com/send?text=https://singaporecovidplaces.netlify.app/ ,  ${selected.location[0].address} , ${selected.date} , ${selected.time}`} target="_blank"><AiOutlineWhatsApp size={24}/></a>
                <a class="telegram" href={`https://t.me/share/url?url=https://singaporecovidplaces.netlify.app/ , ${selected.location[0].address} , ${selected.date} , ${selected.time}`} target="_blank"><FaTelegram size={24}/></a>
              </div>
              <div className='safe-entry'>
                <i className='wereyouthere'>Check Wereyouthere? &nbsp;&nbsp;</i>
                <a href='https://wereyouthere.safeentry.gov.sg/' className='safe-entry-img-a'><img src={safeentryimg} className='safe-entry-img'></img></a>
              </div>
          </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
}